module.exports = __webpack_public_path__ + "static/media/photo290.0f8e5fb3.jpg";